// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zKQG","label":"styles_label__3IYfB"};